import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Path } from './base/Icon';
import type { VoteIconProps } from './types';
const VoteIcon: React.FC<VoteIconProps> = t0 => {
  const $ = _c(13);
  let color;
  let props;
  let t1;
  let t2;
  let type;
  if ($[0] !== t0) {
    ({
      size: t1,
      type,
      filled: t2,
      color,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = color;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = type;
  } else {
    color = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    type = $[5];
  }
  const size = t1 === undefined ? 30 : t1;
  const filled = t2 === undefined ? false : t2;
  const fillColor = filled ? color : "none";
  const isUpvote = type === "UPVOTE";
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Path d="M15 26.25L3.75 17.5L9.9875 17.5L10 3.75L20 3.75L20 17.5H26.25L15 26.25Z" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== color || $[8] !== fillColor || $[9] !== isUpvote || $[10] !== props || $[11] !== size) {
    t4 = <Icon {...props} size={size} viewBox="0 0 30 30" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" flip={isUpvote} fill={fillColor}>{t3}</Icon>;
    $[7] = color;
    $[8] = fillColor;
    $[9] = isUpvote;
    $[10] = props;
    $[11] = size;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default VoteIcon;